//layouts
import LayoutBasic from '../layouts/LayoutBasic';
//pages
import Home from '../pages/Home';
import User from '../pages/User';
import Error404 from '../pages/Error404';


const routes = [
  {
    path: "/",
    layout: LayoutBasic,
    component: Home,
  },
  {
    path: "/:username",
    layout: LayoutBasic,
    component: User,
  },
  {
    path: "*",
    layout: LayoutBasic,  
    component: Error404,
  },
];

export default routes;